import React, { useState } from "react";
import { IoIosArrowDown } from "react-icons/io";

const SingleNavItem = ({ label, link, children, handleNavigate, closeSideMenu }) => {
  const [isItemOpen, setItemOpen] = useState(false);

  const toggleItem = (e) => {
    e.stopPropagation(); 
    setItemOpen(!isItemOpen);
  };

  const handleClick = (e, linkValue) => {
    e.preventDefault();
    handleNavigate(linkValue);
    closeSideMenu();
  };

  return (
    <div className="relative px-2 py-2 transition-all">
      {/* For simple links */}
      {!children && (link || link === "") ? (
        <button
          onClick={(e) => handleClick(e, link)}
          className="flex items-center gap-2 text-darkText w-full text-left"
        >
          {label}
        </button>
      ) : (
        <p
          onClick={toggleItem}
          className="flex cursor-pointer items-center gap-2 text-darkText"
        >
          <span>{label}</span>
          {children && (
            <IoIosArrowDown
              className={`text-xs transition-all ${
                isItemOpen && "rotate-180"
              }`}
            />
          )}
        </p>
      )}

      {/* Dropdown */}
      {isItemOpen && children && (
        <div className="flex w-auto flex-col gap-1 rounded-lg bg-white py-1 transition-all">
          {children.map((child, idx) => (
            <button
              key={idx}
              onClick={(e) => handleClick(e, child.link)}
              className="flex cursor-pointer items-center py-1 pl-6 pr-8 text-darkText w-full text-left"
            >
              {child.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};


export default SingleNavItem;
